import React from 'react'
import { Link } from 'react-router-dom'
//import {IsLoggedContext} from '../Store'
import logo from '../Clear Logo.png'
//import address from '../server'
import '../styles/login.css'
import LoginButton from './LoginButton'
const SignUp = () => {
	//const [username] = useState("")
	//const [password] = useState("")
	//const [email] = useState("")
	//const [,setIsLogged] = useContext(IsLoggedContext)
	//const [day] = useState('')
	//const [year] = useState('')
	//const [month, setMonth] = useState('')

	/*function validateEmail () {
		const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return regexp.test(email);
	  }*/


	/*const numsOnly = (e, dayOrYear) => {
	const re = /^[0-9\b]+$/;
	const re2 = /^[0-9\b]+$/;
	if(dayOrYear === 'day'){      
	if (e.target.value === '' || re.test(e.target.value)) {
		setDay(e.target.value)
	} 
	} else if(dayOrYear === 'year'){
	if (e.target.value === '' || re2.test(e.target.value)) {
		setYear(e.target.value)
	} 
	}
}*/


	/*const handleSignUp = (event) => {
		event.preventDefault()
		if(!validateEmail()) {
			alert('Please enter a valid email')
			return
		}
		if(password.length < 5) {
		alert('please create a five letter or more password')
		return;
		} else if(password.includes(" ")) {
		alert('please no spaces in password')
		return;
		} else if(username.length === 1) {
		alert('please have enter name longer than a letter!')
		return;
		} else if(username.length > 20){
		alert('username is too long!')
		return;
		} else if(day > 31) {
		alert('please enter a valid day')
		return;
		} else if(username.includes(" ")) {
		alert('please no spaces in username!')
		return;
		}

		const currentYear = new Date().getFullYear()
		if(year > currentYear || year < 1900){
		alert('please enter a valid year!')
		return;
		} else if(currentYear - year < 13){
		alert('Unfortunately you are not old enough to sign up')
		return;
		}
		if(+day < 1) {
		alert('please enter a valid day')
		return;
		}
		if(username !== '' && password !== '') {
			const requestOptions = {
				method: 'POST',
				headers: { 
				'content-type': 'application/json' },
				body: JSON.stringify({ username: username, email: email, password: password })
			};

			fetch(address + '/register', requestOptions).then(res => res.json()).then(data => {
			if(data.status === 'success') {
				localStorage.setItem("loggedIn", username)
				const getSess = localStorage.getItem('loggedIn')
			//  console.log(getSess)
			setIsLogged(getSess)
			// console.log(isLogged)
			//  setIsLogged(localStorage.getItem('loggedIn'))
			} else if(data.status === 'exists') {
				alert('User already exists!')
			}
			});
		}else {
		alert('Fill in password or username!')
		}
	}*/

	return (
		<>
			<div className="loginContainer">
				<div className="loginOverlay"></div>
			</div>
			<div className="loginForm">
				<Link to="/" style={{paddingTop: 10}}>
					<img src={logo} alt="" className="loginLogo"></img>
				</Link>
				<h1>Clusterfy</h1>
				<p>Achieve your greatest potential.</p>
				<LoginButton styleOpt={false} text="Sign Up"/>					
			</div>
			<div className="privacyPolicyBanner">
				By using this site you agree to our <a href="/terms">terms and conditions</a> as well as our <a href="/privacypolicy">privacy policy</a>.
			</div>
		</>
	)
}

export default SignUp